import React from 'react';
import Header from "../components/custom/header";
import ViewDocuments from '../components/claims-documents/view-documents';
import SessionTimeout from "../components/session-timeout";

const ViewDocumentsPage = () => {

    return (
        <React.Fragment>
            {
                <div>
                    <Header />
                    <ViewDocuments/>
                    <SessionTimeout/>
                </div>
            }
        </React.Fragment>
    )
}

export default (ViewDocumentsPage);
